import i18n from 'i18next';

interface ValidationFunc {
    (input1: any, input2?: any, input3?: any): true | string; //return true for correct, return msg for invalid
}

export const validatePassword: ValidationFunc = (password: string, is_confirm_password: boolean = false) => {
    const minLength = 8;
    const maxLength = 32;
    const hasLowerLetter = /[a-z]/;
    const hasUpperLetter = /[A-Z]/;
    const hasNumber = /[0-9]/;

    if (!password)
        if(is_confirm_password) return "パスワード確認は必須です。"
        else return "パスワードは必須です。"

    if (password.length < minLength || !hasLowerLetter.test(password) || !hasUpperLetter.test(password) || !hasNumber.test(password))
        return "パスワードはアルファベット大文字・小文字、数字を組み合わせて8桁以上で設定してください。";

    if (password.length > maxLength)
        return "パスワードはアルファベット大文字・小文字、数字を組み合わせて8桁以上32文字以内で設定してください。";

    return true
}

export const validateRequired = (str: string, textField: string) => {
    if(str === "" || str === null || (typeof str == 'string' && !str.trim())) {
        return textField + 'は必須です。';
    }
    return true;
}

export const validateNameKatakana = (str: string, textField: string) => {
    if(!str) {
        return true;
    }
    const katakanaRegex = /^[\u30A0-\u30FFー\s]+$/;
    if (!katakanaRegex.test(str))
        return textField + '（カナ）を入力してください。';
    return true
}

export const validateOptionsRequired = (options: any, textField: string, field: string) => {
    if (Array.isArray(options) && options.every((option: any) => !option.value)) {
        if (field == 'talent_type') 
            return 'タレントの種別はひとつ以上選択してください。';
        return textField + 'は必須です。';
    } 
    return true;
}

export const validateFieldReq: ValidationFunc = (field: string, fieldName: string) => {
    if (!field || (typeof field == 'string' && !field.trim()))
        return `${fieldName}は必須です。`
    return true
}

export const validateEmail: ValidationFunc = (email: string) => {
    if (!email)
        return i18n.t('MSG_GLOBAL_EMAIL_REQUIRED')

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email))
        return i18n.t('MSG_GLOBAL_INVALID_EMAIL_FORMAT')
    return true
}

export const isValidTagString = (tagString: string): boolean => {
  if (!tagString) return true;

  const forbiddenChars = [';', '"', '<', '>', '@', '#'];
  if (forbiddenChars.some(char => tagString.includes(char))) {
    return false;
  }

  const tags = tagString.split(",").map(tag => tag.trim());

  const tagRegex = /^[^;"<>\s,@#][^;"<>@#]*$/u;

  return tags.every(tag => tag.length > 0 && tagRegex.test(tag));
};

export const isValidJoinDateLeaveDate = (joinYear: integer, joinMonth: integer, leaveYear: integer, leaveMonth: integer): boolean => {
    if (!joinYear) return true;
    if (!leaveYear) return true;
  
    if(joinYear > leaveYear) {
        return false
    }
    if(joinYear < leaveYear) {
        return true
    }
    if(!joinMonth || !leaveMonth) {
        return true
    }
    if(joinMonth > leaveMonth) {
        return false
    }
    return true
};
